module.exports = __webpack_public_path__ + "img/cszq_partners_5.70307985.jpg";